<template>
    <div class="insureDetail">
        <v-head></v-head>
        <div class="contentBox">
            <div class="top">
                <div class="leftimg">
                    <template v-if="detailsData.productDetailImg">
                        <img :src="detailsData.productDetailImg[0].url"
                            v-if="detailsData.productDetailImg.length == 1" />
                        <el-carousel height="380px" v-else>
                            <el-carousel-item v-for="item in detailsData.productDetailImg" :key="item.uid">
                                <img :src="item.url" alt="" />
                            </el-carousel-item>
                        </el-carousel>
                    </template>
                </div>
                <div class="righttext">
                    <a target="_blank" :href="detailsData.policyTemplate[0].url" v-if="
                        detailsData.policyTemplate &&
                        detailsData.policyTemplate.length > 0
                    " class="policyTemplate">
                        <i class="el-icon-document"></i>保单模版
                    </a>
                    <a target="_blank" :href="detailsData.gzzl[0].url" v-if="
                        detailsData.gzzl &&
                        detailsData.gzzl.length > 0
                    " class="policyTemplate policyTemplate2">
                        <i class="el-icon-document"></i>盖章资料
                    </a>
                    <div>
                        <p>
                            <i class="tit"> 产品名称：</i>
                            <span>{{ detailsData.productName }}</span>
                        </p>
                        <p>
                            <i class="tit"> 产品编号：</i>
                            <span>{{ detailsData.productCode }}</span>
                        </p>
                        <p>
                            <i class="tit"> 产品简介：</i>
                            <span v-for="(item, index) in detailsData.productHigh" :key="index"><img
                                    src="@/assets/images/product/anq.png" />{{ item }}</span>
                        </p>
                        <div class="ritit">
                            <i class="tit"> 负责人： </i>
                            <div v-html="detailsData.productFuzeren"></div>
                        </div>
                        <div class="ritit">
                            <i class="tit"> 产品描述： </i>
                            <div v-html="detailsData.desc"></div>
                        </div>

                    </div>
                    <div>
                        <p>
                            <span style="color: #e46e22" v-if="isCanCommission == 1">
                                佣金：{{ detailsData.proCommission }}%
                            </span>
                            保费： {{ detailsData.baseMoney }}元/人起
                        </p>
                        <el-button type="primary" @click="MYskip" v-if="
                            product_id == '1001371' ||
                            product_id == '1001370' ||
                            product_id == '1001380' ||
                            product_id == '1001379'
                        ">
                            立即投保
                        </el-button>
                        <el-button type="primary" @click="skip" v-else>
                            立即投保
                        </el-button>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div class="titbox">
                    <div>投保提示</div>
                    <ul>
                        <li v-for="item in detailsData.occupationCate" :key="item.uid">
                            <a :href="item.url" target="_blank" rel="noopener noreferrer" download>
                                <i class="iconfont icon-a-xiazai3"></i>下载《职业类别》
                            </a>
                        </li>
                        <template v-if="
                            product_id != '1001371' &&
                            product_id != '1001370' &&
                            product_id != '1001380' &&
                            product_id != '1001379'
                        ">
                            <li v-for="item in detailsData.insureFile" :key="item.uid">
                                <a :href="item.url" target="_blank" rel="noopener noreferrer" download>
                                    <i class="iconfont icon-a-xiazai3"></i>
                                    下载《投保资料》
                                </a>
                            </li>
                        </template>
                        <template v-else>
                            <template v-if="detailsData.insureFile">
                                <li v-if="detailsData.insureFile[0]">
                                    <a :href="detailsData.insureFile[0].url" target="_blank" rel="noopener noreferrer"
                                        download>
                                        <i class="iconfont icon-a-xiazai3"></i>
                                        投保重要事项确认书
                                    </a>
                                </li>
                                <li v-if="detailsData.insureFile[1]">
                                    <a :href="detailsData.insureFile[1].url" target="_blank" rel="noopener noreferrer"
                                        download>
                                        <i class="iconfont icon-a-xiazai3"></i>
                                        客户告知书
                                    </a>
                                </li>
                            </template>
                        </template>
                    </ul>
                </div>
                <div class="textbox">
                    <p style="font-weight: bold;">
                        更新说明：<span>{{ detailsData.updateInfo }}</span>
                    </p>
                    <p style="font-weight: bold;">
                        承保年龄：<span>{{ detailsData.insureAge }}</span>
                    </p>
                    <p>
                        保障期限：<span>{{ detailsData.insureTime }}</span>
                    </p>
                    <p>
                        起保人数：
                        <span v-if="
                            product_id == '1001371' ||
                            product_id == '1001370' ||
                            product_id == '1001380' ||
                            product_id == '1001379'
                        ">仅含1-4类3人起保，含5-6类5人起保，支持按月投保</span>
                        <span v-else>{{ detailsData.insureNum }}</span>
                    </p>
                    <p style="font-weight: bold;">
                        承保职业：<span>
                            {{ detailsData.insureWork }}
                        </span>
                    </p>
                    <p style="display: block; font-weight: bold;">
                        <template v-if="
                            product_id == '1001291' ||
                            product_id == '1001292' ||
                            product_id == '1001293'
                        ">投保人名称中含有以下字段的企业不予承保：
                        </template>
                        <template v-else> 不属于承保范围行业：</template>
                        <span style="display: block;text-indent:30px;">
                            {{ detailsData.nonInsured }}
                        </span>
                    </p>
                    <template v-if="
                        product_id == '1001371' ||
                        product_id == '1001370' ||
                        product_id == '1001380' ||
                        product_id == '1001379'
                    ">
                        <!-- 美亚的 -->
                        <p style="display: block;font-weight: bold;">
                            属于承保范围地区：
                            <span> 中国大陆，不含港澳台 </span>
                        </p>
                    </template>
                    <template v-else>
                        <p style="display: block;font-weight: bold;">
                            拒保地区（企业注册地）：
                            <span> {{ detailsData.noInsureArea }} </span>
                        </p>
                        <template v-if="detailsData.workAddress">
                        <p style="display: block;font-weight: bold;">
                            拒保施工地：
                            <span> {{ detailsData.workAddress }} </span>
                        </p>
                        </template>
                        <p>
                            收单时间：
                            <span> {{ detailsData.endTime }} </span>
                        </p>
                    </template>
                </div>
                <div class="tabsBox">
                    <div class="tabsTit">
                        <p @click="activeName = 1">
                            <img :src="activeName == 1
                                    ? require('@/assets/images/product/capsule_left_a.png')
                                    : require('@/assets/images/product/capsule_left.png')
                                " />
                            <span :class="activeName == 1 ? 'active' : ''">产品详情</span>
                        </p>
                        <p @click="activeName = 2">
                            <img :src="activeName == 2
                                    ? require('@/assets/images/product/capsule_center_a.png')
                                    : require('@/assets/images/product/capsule_center.png')
                                " />
                            <span :class="activeName == 2 ? 'active' : ''">投保须知</span>
                        </p>
                        <p @click="activeName = 3">
                            <img :src="activeName == 3
                                    ? require('@/assets/images/product/capsule_center_a.png')
                                    : require('@/assets/images/product/capsule_center.png')
                                " />
                            <span :class="activeName == 3 ? 'active' : ''">保险条款</span>
                        </p>
                        <p @click="activeName = 4">
                            <img :src="activeName == 4
                                    ? require('@/assets/images/product/capsule_center_a.png')
                                    : require('@/assets/images/product/capsule_center.png')
                                " />
                            <span :class="activeName == 4 ? 'active' : ''">常见问题</span>
                        </p>
                        <p @click="activeName = 5">
                            <img :src="activeName == 5
                                    ? require('@/assets/images/product/capsule_left_a.png')
                                    : require('@/assets/images/product/capsule_left.png')
                                " />
                            <span :class="activeName == 5 ? 'active' : ''">理赔流程</span>
                        </p>
                    </div>
                    <div class="tabsContent">
                        <!-- 产品详情 -->
                        <div class="textBox" v-show="activeName == 1">
                            <div v-html="detailsData.productDesc"></div>
                            <p class="tit">隐私保护声明</p>
                            <div v-html="detailsData.privacyDesc"></div>
                            <p class="tit">特别约定</p>
                            <div v-html="detailsData.importantNotices"></div>
                        </div>
                        <!-- 投保须知 -->
                        <div class="textBox" v-show="activeName == 2">
                            <p v-for="item in detailsData.insuranceNotice" :key="item.uid">
                                <a :href="item.url" target="_blank" download>
                                    {{ item.name }}
                                </a>
                            </p>
                            <p v-for="item in detailsData.specialAgreement" :key="item.uid">
                                <a :href="item.url" target="_blank" download>
                                    {{ item.name }}
                                </a>
                            </p>
                        </div>
                        <!-- 保险条款 -->
                        <div class="textBox" v-show="activeName == 3">
                            <p v-for="item in detailsData.insureClause" :key="item.uid">
                                <a :href="item.url" target="_blank" download>
                                    {{ item.name }}
                                </a>
                            </p>
                        </div>
                        <!-- 常见问题 -->
                        <div class="textBox" v-show="activeName == 4">
                            <div class="issue">
                                <p class="issueTit">
                                    <span>
                                        1
                                    </span>
                                    本产品指定的医院范围为？
                                    <i class="el-icon-arrow-down"
                                        @click="issue1 ? (issue1 = false) : (issue1 = true)"></i>
                                </p>
                                <div class="issueCon" v-show="issue1">
                                    中华人民共和国卫生部门评审确定的二级或二级以上的公立医院普通部。
                                </div>
                            </div>
                            <div class="issue">
                                <p class="issueTit">
                                    <span>
                                        2
                                    </span>
                                    高空作业最高可承担到几米的责任？
                                    <i class="el-icon-arrow-down"
                                        @click="issue2 ? (issue2 = false) : (issue2 = true)"></i>
                                </p>
                                <div class="issueCon" v-show="issue2">
                                    <template v-if="
                                        product_id == '1001291' ||
                                        product_id == '1001292' ||
                                        product_id == '1001293'
                                    ">
                                        本保险仅承保5米以下高空作业
                                    </template>
                                    <template v-else>
                                        国家标准GB/T3608-2008《高处作业分级》规定：“凡在坠落高度基准面2m以上（含2m）有可能坠落的高处进行作业，都称为高处作业。”，被保险人雇员从事高处作业时因未系绑安全带导致的保险事故属除外责任。：</template>
                                </div>
                            </div>
                        </div>
                        <!-- 理赔流程 -->
                        <div class="textBox" v-show="activeName == 5">
                            <div class="flow">
                                <!-- <p class="flowTit">
                  <img src="@/assets/images/product/flowTitbg.png" alt="" />
                  <span>方案1</span>
                </p> -->
                                <div class="flowCon">
                                    <template v-if="product_id == 100002 || product_id == 100003">
                                        <p>
                                            1、理赔报案方式
                                        </p>
                                        <p style="text-indent:30px;">
                                            方式一：24小时客服热线报案：400-800-2020（身故伤残、涉三者责任、索赔金额大于3000元推荐）
                                            方式二：线上平台报案：企业登录-管理中心-理赔服务-理赔申请https://partner.jdallianz.com（索赔金额3000元(含)以内推荐，免提交原件）
                                        </p>
                                        <p>2、报案所需信息</p>
                                        <p style="margin-left:30px;">
                                            （1）保单号码<br />
                                            （2）发生事故的雇员（伤者）姓名、身份证件号、工种类别、联系人、联系方式<br />
                                            （3）事故发生时间、地点、详细经过，就诊医院，雇员（伤者）目前状况，损伤程度等
                                        </p>
                                        <p>3、理赔申请方式</p>
                                        <p style="margin-left:30px;">
                                            请将所需理赔材料邮寄至以下地址，邮寄费用需由索赔人自行承担，恕不接收到付货件，敬请见谅。
                                            收件地址：广州市珠江新城珠江西路5号广州国际金融中心34楼10单元
                                            京东安联财险（邮政编码：510623）收件人：理赔部（雇主险）
                                            电话：020-85132900
                                        </p>
                                        <p>4、理赔所需材料</p>
                                        <p style="margin-left:30px;">
                                            （1）索赔申请表原件<br />
                                            （2）员工身份证和劳动合同复印件<br />
                                            （3）医疗费用发票和清单原件<br />
                                            （4）医疗资料（如病历/检查报告等）<br />
                                            （5）医生出具的病假证明（涉及误工费提供）<br />
                                            （6）考勤记录和工资支付记录（涉及误工费提供）<br />
                                            （7）伤残鉴定报告（涉及伤残提供）<br />
                                            （8）公司和员工赔偿协议和支付凭证（涉及身故伤残提供）<br />
                                            （9）死亡证明（涉及身故提供）<br />
                                            （10）工伤认定书、社保赔付单原件（如适用）<br />
                                            （11）警方报告（如适用）
                                        </p>
                                        <p>5、理赔时效</p>
                                        <p style="margin-left:30px;">
                                            提交完整理赔材料后，保险公司按以下理赔时效给予核定并反馈:
                                        </p>
                                        <table class="tablelipei">
                                            <tr>
                                                <td>赔款项目</td>
                                                <td>理赔时效</td>
                                            </tr>
                                            <tr>
                                                <td>医疗费用、误工费、住院津贴</td>
                                                <td>10个工作日内</td>
                                            </tr>
                                            <tr>
                                                <td>涉及身故/伤残</td>
                                                <td>根据案件复杂程度而定，最长不超过30日</td>
                                            </tr>
                                        </table>
                                    </template>
                                    <template v-else-if="
                                        product_id == '1001291' ||
                                        product_id == '1001292' ||
                                        product_id == '1001293'
                                    ">
                                        <p>
                                            1、出险报案
                                        </p>
                                        <p style="margin-left:30px;">
                                            （1）拨打24小时客服热线95550报案；<br />
                                            （2）微信搜索“AXAINS”或“安盛天平保险”关注我司微信公众号-注册-我的-在线理赔完成报案<br />
                                            （3）登入安盛天平保险官网https://www.axa.cn/-客户服务-在线理赔完成报案
                                        </p>
                                        <p>2、准备材料</p>
                                        <p style="margin-left:30px;">
                                            客户需按照保司要求提交理赔材料
                                        </p>
                                        <p>3、材料审核</p>
                                        <p style="margin-left:30px;">
                                            保司及时对客户提交的理赔材料进行审核、调查、反馈结果
                                        </p>
                                        <p>4、理赔结案</p>
                                        <p style="margin-left:30px;">
                                            -
                                            属于保险责任的，保司会和客户沟通确认理赔信息，并短信通知客户理赔金额，在约定时效内将理赔款转账至被保险人指定的账户。<br />
                                            -
                                            不属于保险责任的，保司在和客户沟通确认理赔结果后发出拒赔通知书并结案。
                                        </p>
                                    </template>
                                    <img src="@/assets/images/product/flowTitimg-1.png" alt="" v-else />
                                    <template v-if="
                                        product_id != '1001291' &&
                                        product_id != '1001292' &&
                                        product_id != '1001293'
                                    ">
                                        <p v-for="item in detailsData.claimsGuide" :key="item.uid">
                                            <a :href="item.url" target="_blank" download>
                                                {{ item.name }}
                                            </a>
                                        </p>
                                        <p class="flowHint">
                                            特别提示：
                                            <br />
                                            1、如伤情严重需先行就医请务必到二级乙等或以上公立医院就医,理赔范围为当地医保可报销范围内用药和必要治疗手段;
                                            <br />
                                            2、如当天未就医请务必在48小时内尽快就医,以免耽误治疗。
                                        </p>
                                    </template>
                                </div>
                            </div>
                            <!-- <div class="flow">
                <p class="flowTit">
                  <img src="@/assets/images/product/flowTitbg.png" alt="" />
                  <span>方案2</span>
                </p>
                <div class="flowCon">
                  <p>
                    直接拨打保险公司客服热线进行报案。此方案报案
                    后，后续事宜需您与保司沟通。
                  </p>
                </div>
              </div> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="fixed">
                <!--  <ul>
           <li @click="drawerVisible = true"><i class="el-icon-date"></i></li> 
          <li @click="dialogVisible = true">
            <i class="el-icon-download"></i>
          </li>
          <li><i class="el-icon-user-solid"></i></li>
          <li @click="up()"><i class="el-icon-arrow-up"></i></li>
        </ul>-->
            </div>
        </div>
        <v-foot :id="detailsData.agent_id" :tit="detailsData.agent_name" v-if="detailsData"></v-foot>
        <!-- 下载弹窗 -->
        <el-dialog title="" :visible.sync="dialogVisible" width="600px" :show-close="false" top="50px">
            <el-scrollbar>
                <img src="http://www.ay1.cc/img?w=800&h=1777&c=ffffff" alt="" />
            </el-scrollbar>
            <a href="http://www.ay1.cc/img?w=800&h=1777" download>
                <i class="el-icon-bottom"></i></a>
        </el-dialog>
        <!-- 侧边栏保费试算 -->
        <el-drawer title="保费试算" :with-header="false" :visible.sync="drawerVisible" :wrapperClosable="true"
            :before-close="drawerClose" size="500px">
            <trial-cost :id="product_id" v-if="drawerVisible"></trial-cost>
        </el-drawer>
    </div>
</template>
<script>
import vHead from "@/components/vhead";
import vFoot from "@/components/vFoot";
import trialCost from "@/components/trialCost/one";
import { getProductDetail } from "@/api/insure";
export default {
    name: "insureDetail",
    components: {
        vHead,
        vFoot,
        trialCost
    },
    data() {
        return {
            isCanCommission: this.$store.getters.isCanCommission, //是否展示佣金
            product_id: "",
            activeName: 1, //下面选项卡
            issue1: true, //问题
            issue2: true, //问题
            dialogVisible: false, //下载弹窗
            detailsData: "",
            // 保费试算抽屉
            drawerVisible: false
        };
    },
    mounted() {
        this.product_id = this.$route.query.product_id;
        this.getProductDetail(); //触发请求数据
    },
    methods: {
        skip() {
            // 页面跳转
            this.$router.push({
                path: "/insure/fillIn",
                query: { id: this.product_id, type: this.detailsData.productCate }
            });
        },
        //美亚方案投保前提示
        MYskip() {
            let that = this;
            let _html =
                `<div>
            您即将进入投保流程，请仔细阅读保险条款、责任免除等重要事项。为维护您的合法权益，您的操作将被安全记录。本产品由美亚财产保险有限公司承保，由白鸽宝保险经纪有限公司提供经纪服务，请详细阅读
            <a
              href="` +
                that.detailsData.insureFile[1].url +
                `"
              target="_blank"
              rel="noopener noreferrer"
              download
              style="color: #409eff;"
            >
              《客户告知书》
            </a>
            。
          </div>`;
            that
                .$alert(_html, "即将进入投保流程提示", {
                    dangerouslyUseHTMLString: true,
                    showCancelButton: true,
                    confirmButtonText: "我已知晓并确认",
                    cancelButtonText: "取消"
                })
                .then(() => {
                    console.log(0);
                    that.$router.push({
                        path: "/insure/fillIn",
                        query: { id: this.product_id, type: this.detailsData.productCate }
                    });
                });
        },
        up() {
            // 返回顶部
            document.getElementById("app").scrollIntoView({ behavior: "smooth" });
        },
        // 获取信息
        getProductDetail() {
            let that = this;
            getProductDetail({ product_id: that.product_id })
                .then(function (res) {
                    console.log(res);
                    if (res.code == 1) {
                        that.detailsData = res.data;
                        // 设置title
                        document.title = "产品详情--" + res.data.productName;
                    } else {
                        that.$message.error(res.msg);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        // 保费试算关闭
        drawerClose(e) {
            this.drawerVisible = false;
        }
    }
};
</script>
<style lang="scss">
.insureDetail {
    &>.el-dialog {
        background: transparent;
        box-shadow: none;

        .el-dialog__header {
            display: none;
        }

        .el-dialog__body {
            .el-scrollbar__wrap {
                max-height: calc(100vh - 160px);
            }

            img {
                max-width: 100%;
                width: 100%;
            }

            a {
                display: inline-block;
                position: absolute;
                width: 100px;
                height: 100px;
                background: #ffffff;
                border-radius: 50%;
                display: flex;
                justify-content: center;
                align-items: center;
                bottom: 35px;
                right: -100px;

                i {
                    color: #000000;
                    font-size: 50px;
                }
            }
        }
    }
}
</style>
<style lang="scss">
.insureDetail {
    background-image: url("~@/assets/images/product/main-bg.png");
    background-size: cover;
    background-color: #eff2f4;
    width: 100%;
    margin-top: 54px;

    .contentBox {
        width: 100%;
        max-width: 1200px;
        margin: 0 auto;

        .top {
            display: flex;
            justify-content: flex-start;
            align-items: flex-end;
            padding: 25px 0 0;
            margin-bottom: 25px;

            .leftimg {
                width: 450px;
                height: 380px;
                overflow: hidden;
                position: relative;
                background: #c4c4c4;
                border-radius: 20px 0px 0px 0px;

                img {
                    vertical-align: middle;
                    object-fit: cover;
                    max-width: 100%;
                    width: 100%;
                    height: 100%;
                }
            }

            .righttext {
                min-height: 330px;
                background: #ffffff;
                box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.04);
                border-radius: 4px 20px 4px 4px;
                padding: 25px 0 0 40px;
                display: flex;
                justify-content: space-between;
                flex-direction: column;
                position: relative;
                flex: 1;

                &>.policyTemplate {
                    background: linear-gradient(90deg, #e46e22 0%, #f59f40 100%);
                    border-radius: 16px;
                    font-size: 12px;
                    font-weight: 400;
                    color: #ffffff;
                    line-height: 17px;
                    position: absolute;
                    top: 20px;
                    right: 18px;
                    padding: 7px 20px;

                    i {
                        margin-right: 5px;
                    }
                }

                &>.policyTemplate2 {
                    background: linear-gradient(90deg, #5c22e4 0%, #405bf5 100%);
                    top: 20px;
                    right: 135px;
                }

                &>div {
                    padding-right: 25px;

                    &>p,
                    .ritit {
                        font-size: 16px;
                        font-weight: 400;
                        color: rgba(0, 0, 0, 1);
                        margin: 0;
                        padding-top: 15px;
                        display: flex;
                        justify-content: flex-start;
                        align-items: flex-start;

                        i.tit {
                            font-style: normal;
                            min-width: 82px;
                        }

                        span {
                            font-weight: 400;
                            color: rgba(0, 0, 0, 0.85);
                            display: inline-block;
                            margin-right: 20px;

                            img {
                                width: 16px;
                                margin-right: 5px;
                                vertical-align: text-bottom;
                            }
                        }

                        div {
                            display: inline-block;
                            line-height: 1.5;

                            p,
                            span {
                                margin: 0;
                            }
                        }
                    }
                }

                &>div+div {
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;

                    p {
                        font-size: 16px;
                        font-weight: 600;
                        color: #e46e22;
                        padding: 0 30px;
                    }

                    .el-button {
                        width: 220px;
                        height: 64px;
                        font-size: 22px;
                        font-weight: 600;
                        color: #ffffff;
                        line-height: 30px;
                        background: linear-gradient(106deg, #ffffff 0%, #fff1e3 100%);
                        background-image: url("~@/assets/images/product/btnbg.png");
                        background-size: cover;
                        border: none;
                    }
                }
            }
        }

        .bottom {
            background: #ffffff;
            box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.07);
            border-radius: 0px 0px 4px 4px;
            margin-bottom: 45px;

            .titbox {
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                border-bottom: 1px solid #97979745;
                padding-right: 20px;

                &>div {
                    position: relative;
                    font-size: 20px;
                    font-weight: 500;
                    color: rgba(0, 0, 0, 0.85);
                    line-height: 64px;
                    padding-left: 30px;
                }

                &>div::before {
                    content: "";
                    display: inline-block;
                    width: 5px;
                    height: 32px;
                    background: #2d8aee;
                    border-radius: 0px 10px 10px 0px;
                    position: absolute;
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                }

                ul {
                    list-style: none;
                    padding: 0;
                    margin: 0;
                    display: flex;
                    align-items: center;
                    line-height: 64px;

                    li {
                        font-size: 14px;
                        font-weight: 400;
                        color: #2d8aee;
                        margin-left: 25px;

                        i {
                            font-size: 14px;
                            margin-right: 3px;
                        }
                    }
                }
            }

            .tabsBox {
                padding: 0 30px 30px;

                .tabsTit {
                    display: inline-flex;
                    justify-items: flex-start;
                    align-items: center;
                    border-radius: 16px;
                    background: #fff;
                    overflow: hidden;

                    p {
                        font-size: 14px;
                        font-weight: 600;
                        color: rgba(0, 0, 0, 0.85);
                        margin: 0;
                        position: relative;
                        width: 116px;
                        cursor: pointer;

                        img {
                            width: 100%;
                            height: 32px;
                            vertical-align: middle;
                        }

                        span {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            width: 100%;
                            text-align: center;
                            line-height: 1;
                        }

                        span.active {
                            color: rgba(255, 255, 255, 0.85);
                        }
                    }

                    p+p {
                        margin-left: -10px;
                    }

                    p:last-child img {
                        transform: rotate(180deg);
                    }
                }

                .tabsContent {
                    padding-top: 20px;

                    .textBox {
                        font-size: 14px;
                        font-weight: 400;
                        color: rgba(0, 0, 0, 0.75);
                        line-height: 2;

                        p {
                            margin: 0;
                        }

                        a:hover {
                            color: #2d8aee;
                        }

                        .tit {
                            font-weight: 600;
                            margin-top: 20px;
                            margin-bottom: 10px;
                        }

                        .tit:before {
                            content: "";
                            width: 8px;
                            height: 8px;
                            border: 2px solid #2d8aee;
                            margin-right: 10px;
                            display: inline-block;
                            transform: rotate(45deg);
                            margin-bottom: 1px;
                        }

                        .issue {
                            background: #ffffff;
                            border: 1px solid #e2e1e1;
                            margin-bottom: 30px;

                            .issueTit {
                                font-size: 14px;
                                font-weight: 600;
                                color: rgba(0, 0, 0, 0.85);
                                position: relative;
                                line-height: 32px;
                                padding: 8px 10px;

                                span {
                                    display: inline-block;
                                    width: 32px;
                                    height: 32px;
                                    background-size: 100%;
                                    background-repeat: no-repeat;
                                    text-align: center;
                                    vertical-align: middle;
                                    color: #fff;
                                    font-weight: 500;
                                    line-height: 28px;
                                    margin-right: 15px;
                                    background-image: url("~@/assets/images/product/issue_num.png");
                                }

                                i {
                                    position: absolute;
                                    top: 50%;
                                    right: 10px;
                                    transform: translateY(-50%);
                                    font-size: 24px;
                                    font-weight: 600;
                                    color: #006bff;
                                    cursor: pointer;
                                    padding: 10px;
                                }
                            }

                            .issueCon {
                                border-top: 1px solid #ededed;
                                padding: 10px 20px 20px;
                            }
                        }

                        .flow {
                            margin-bottom: 20px;

                            .flowTit {
                                position: relative;
                                width: 95px;
                                height: 40px;
                                margin-bottom: 15px;

                                span {
                                    font-size: 16px;
                                    font-weight: 500;
                                    color: #2d8aee;
                                    position: absolute;
                                    top: 45%;
                                    left: 50%;
                                    transform: translate(-50%, -50%);
                                }
                            }

                            .flowCon {
                                padding-left: 4px;

                                p {
                                    font-size: 16px;
                                    font-weight: 400;
                                    color: rgba(0, 0, 0, 0.85);
                                    line-height: 22px;
                                }

                                img {
                                    max-width: 100%;
                                    padding: 0 0 20px;
                                }

                                .flowHint {
                                    font-size: 14px;
                                    font-weight: 400;
                                    color: #00000080;
                                    line-height: 20px;
                                    margin-top: 20px;
                                }

                                .tablelipei {
                                    width: 100%;
                                    border-collapse: collapse;
                                    margin: 10px 0 10px 30px;

                                    td {
                                        border: 1px solid #ccc;
                                        padding: 3px;
                                        text-align: center;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .textbox {
                padding: 20px 30px 30px;

                &>p {
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(0, 0, 0, 1);
                    line-height: 36px;
                    margin: 0;
                    display: flex;
                    justify-content: flex-start;

                    span {
                        color: rgba(0, 0, 0, 0.85);
                        max-width: calc(100% - 75px);
                        flex: 1;
                    }
                }
            }
        }

        .fixed {
            position: fixed;
            bottom: 350px;
            right: 300px;

            ul {
                padding: 0;
                margin: 0;
                list-style: none;

                li {
                    background: #fbfbfb;
                    border-radius: 7px;
                    border: 1px solid #e5e5e5;
                    width: 70px;
                    height: 70px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-top: 15px;
                    cursor: pointer;
                    font-size: 30px;
                    color: #4f4f4f;
                }

                li:hover {
                    background: #4f8bf0;
                    color: #fff;
                }
            }
        }
    }
}
</style>
